import React from 'react';
import Formsy from 'formsy-react';
import { Typography, Box } from '@material-ui/core';
import { refSetter } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';
import ApiSelector from '../../../containers/common/selectors/selectorContainer';
import { bandsEndpoint, ragsEndpoint, getPreferredCliniciansEndpointForTreatment } from '../../../settings/constants';
import { ragStatusWithDesc, Band } from '../../../enums';
import _ from '../../../utils/lodash';
import ConfirmationDialog from '../../../components/PageStructure/ConfirmationDialog';

const locale = globals.getArea('treatments');

const defaultState = props => ({
  selectedRag: props.treatment.overriddenRagStatus,
  selectedBand: props.treatment.overriddenBand,
  selectedPreferredClinicianId: props.treatment.preferredClinicianId,
  selectedPreferredClinician: props.treatment.preferredClinician,
  patientFullName: props.patientFullName,
  showConfirmationDialog: false,
});

class PersonaliseTreatment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...defaultState(this.props),
    };
  }
  setRef = refSetter.bind(this);

  getActivitiesHighestRag = activities => {
    const ragStatuses = activities.map(activity => activity.ragStatus);
    const ragStatusesWithDesc = _.filter(ragStatusWithDesc, r => {
      return ragStatuses.find(x => x.id === r.id);
    });
    const maxRagStatus = ragStatusesWithDesc.reduce((max, x) => (max.sortingOrder > x.sortingOrder ? max : x), 0);

    return ragStatuses.find(x => x.id === maxRagStatus.id);
  };

  getActivitiesHighestBand = activities => {
    const bands = activities.map(activity => activity.band);
    const bandsIds = bands.map(x => x.id);
    const maxBandId = Math.max(...bandsIds);

    return bands.find(x => x.id === maxBandId);
  };

  handleRagChange = (event, key, id, rag) => {
    this.setState({
      ...this.state,
      selectedRag: rag,
      showConfirmationDialog: false,
    });
  };

  handleBandChange = (event, key, id, band) => {
    if (
      this.state.selectedPreferredClinician !== undefined &&
      this.state.selectedPreferredClinician !== null &&
      this.state.selectedPreferredClinician.clinicianBand < band.id
    ) {
      this.setState({
        ...this.state,
        selectedBand: band,
        showConfirmationDialog: true,
      });
    } else {
      this.setState({
        ...this.state,
        selectedBand: band,
        showConfirmationDialog: false,
      });
    }
  };

  handlePreferredClinicianChange = (event, key, id, selectedPreferredClinician) => {
    if (
      selectedPreferredClinician !== undefined &&
      selectedPreferredClinician !== null &&
      this.state.selectedBand != null &&
      selectedPreferredClinician.clinicianBand < this.state.selectedBand.id
    ) {
      this.setState({
        ...this.state,
        selectedPreferredClinicianId: id,
        selectedPreferredClinician,
        showConfirmationDialog: true,
      });
    } else {
      this.setState({
        ...this.state,
        selectedPreferredClinicianId: id,
        selectedPreferredClinician,
        showConfirmationDialog: false,
      });
    }
  };

  handleConfirm = () => {
    this.setState({
      ...this.state,
      showConfirmationDialog: false,
      selectedPreferredClinicianId: null,
      selectedPreferredClinician: null,
    });
  };

  handleCancel = () => {
    this.setState({
      ...this.state,
      showConfirmationDialog: false,
      selectedBand: this.props.treatment.overriddenBand,
    });
  };

  filterRagOptions = options => {
    const defaultRagStatus = this.getActivitiesHighestRag(this.props.activities).id;
    if (!_.isEmpty(this.props.treatment.overriddenRagStatus)) {
      return options.filter(
        o => parseInt(o.description, 10) >= ragStatusWithDesc.find(x => x.id === defaultRagStatus).sortingOrder,
      );
    }
    return options.filter(
      o => parseInt(o.description, 10) > ragStatusWithDesc.find(x => x.id === defaultRagStatus).sortingOrder,
    );
  };

  filterBandOptions = options => {
    if (!_.isEmpty(this.props.treatment.overriddenBand)) {
      return options.filter(o => o.id >= this.getActivitiesHighestBand(this.props.activities).id);
    }
    return options.filter(o => o.id > this.getActivitiesHighestBand(this.props.activities).id);
  };

  shouldDisableSelector = (value, options) => {
    if (!_.isEmpty(value)) {
      const highestOption = options.reduce((max, x) => (max.sortingOrder > x.sortingOrder ? max : x));
      return value.id === highestOption.id;
    }
    return false;
  };

  reset = () => {
    this.setState({
      ...defaultState(this.props),
    });
  };

  render() {
    const { innerRef, activities } = this.props;

    const headerStyle = {
      marginTop: '16px',
      marginBottom: '20px',
    };
    const defValueTextColour = {
      color: '#00B1EB',
    };

    return (
      <Box display="flex" flexDirection="column">
        <Formsy.Form ref={innerRef} onSubmit={this.handleSubmit} className="tab-box">
          <Typography variant="h4" style={headerStyle}>
            {locale.getMsg('personaliseTreatmentDescription')}
          </Typography>
          <Box display="flex">
            <Box p={3} flexGrow={1} style={{ width: '33%' }}>
              <h6 className="MuiTypography-root MuiTypography-h6">{locale.getMsg('treatRagStatusLbl')}</h6>
            </Box>
            <Box p={1} flexGrow={1} style={{ width: '25%' }}>
              <h6 className="MuiTypography-root MuiTypography-h6" style={defValueTextColour}>
                {locale.getMsg('defaultRagStatus')}
              </h6>
              <Typography style={{ paddingLeft: '10px' }}>
                {activities.length > 0 && this.getActivitiesHighestRag(activities).name}
              </Typography>
            </Box>
            <Box p={1} flexGrow={1} style={{ width: '20%' }}>
              <ApiSelector
                name="ragStatuses"
                floatingLabelText={`${locale.getMsg('overrideRagStatus')}`}
                innerRef={this.setRef('rags')}
                reduxIdentifier="rags"
                endpoint={ragsEndpoint}
                onChange={this.handleRagChange}
                value={this.state.selectedRag}
                autoWidth
                isFetchRequired
                shouldCompareNatural={false}
                disabled={this.shouldDisableSelector(this.getActivitiesHighestRag(activities), ragStatusWithDesc)}
                filterOptions={activities.length > 0 && this.filterRagOptions}
              />
            </Box>
            <Box p={1} flexGrow={1} style={{ width: '24%' }} />
          </Box>
          <Box display="flex">
            <Box p={3} flexGrow={1} style={{ width: '33%' }}>
              <h6 className="MuiTypography-root MuiTypography-h6">{locale.getMsg('treatBandLbl')}</h6>
            </Box>
            <Box p={1} flexGrow={1} style={{ width: '25%' }}>
              <h6 className="MuiTypography-root MuiTypography-h6" style={defValueTextColour}>
                {locale.getMsg('defaultBand')}
              </h6>
              <Typography style={{ paddingLeft: '10px' }}>
                {activities.length > 0 && this.getActivitiesHighestBand(activities).name}
              </Typography>
            </Box>
            <Box p={1} flexGrow={1} style={{ width: '20%' }}>
              <ApiSelector
                name="bands"
                floatingLabelText={`${locale.getMsg('overrideBand')}`}
                innerRef={this.setRef('bands')}
                reduxIdentifier="bands"
                endpoint={bandsEndpoint}
                onChange={this.handleBandChange}
                value={this.state.selectedBand}
                originalValue={this.getActivitiesHighestBand(activities)}
                autoWidth
                isFetchRequired
                disabled={this.shouldDisableSelector(this.getActivitiesHighestBand(activities), Band)}
                filterOptions={activities.length > 0 && this.filterBandOptions}
              />
            </Box>
            <Box p={1} flexGrow={1} style={{ width: '24%' }} />
          </Box>
          <Typography variant="h4" style={headerStyle}>
            {locale.getMsg('preferredClinicianDescription', [this.props.patientFullName])}
          </Typography>
          <Box>
            <Box p={1} flexGrow={1} style={{ width: '50%' }}>
              <ApiSelector
                name="clinicans"
                floatingLabelText={`${locale.getMsg('clinicians')}`}
                innerRef={this.setRef('clinicians')}
                reduxIdentifier="clinicians"
                endpoint={getPreferredCliniciansEndpointForTreatment(this.props.treatment.id)}
                onChange={this.handlePreferredClinicianChange}
                value={this.state.selectedPreferredClinician}
                autoWidth
                isFetchRequired
                shouldCompareNatural={false}
                multiple={false}
                showSelectorChip={this.state.selectedPreferredClinicianId != null}
              />
            </Box>
          </Box>
          <ConfirmationDialog
            isOpen={this.state.showConfirmationDialog}
            confirmationTitle={'Change Overridden band'}
            confirmationDesc={`${locale.getMsg('changeOverriddenBand')}`}
            onConfirm={this.handleConfirm}
            onClose={this.handleCancel}
          />
        </Formsy.Form>
      </Box>
    );
  }
}

PersonaliseTreatment.defaultProps = {
  onFieldsUpdate: () => {},
  innerRef: () => {},
  setValidity: () => {},
  readOnly: false,
};

export default PersonaliseTreatment;
